import type { RedoTableColumn } from "@redotech/redo-web/arbiter-components/tables/redo-table";
import { RedoTableTextCell } from "@redotech/redo-web/arbiter-components/tables/redo-table-cells";
import { StandardRedoTableHeaderCell } from "@redotech/redo-web/arbiter-components/tables/redo-table-header-cells";

/** A column showing when a row was created and which admin created it. */
export function createdColumn<
  T extends { createdAt: string; createdBy: string },
>(headerText: string): RedoTableColumn<T> {
  return {
    key: "created",
    renderHeaderCell: () => (
      <StandardRedoTableHeaderCell headerText={headerText} />
    ),
    renderNormalCell: ({ row }) => (
      <RedoTableTextCell
        subtext={row.createdBy}
        text={new Date(row.createdAt).toLocaleDateString()}
      />
    ),
  };
}
